/**
 * Platform detection utilities for Capacitor / Web hybrid support.
 * Allows the same codebase to run in a browser and in a native iOS/Android shell.
 */

declare global {
  interface Window {
    Capacitor?: {
      isNativePlatform: () => boolean
      getPlatform: () => string
    }
  }
}

/** True when running inside a Capacitor native shell (iOS/Android) */
export function isCapacitor(): boolean {
  return typeof window !== 'undefined' && !!window.Capacitor?.isNativePlatform?.()
}

export function isIOS(): boolean {
  return isCapacitor() && window.Capacitor!.getPlatform() === 'ios'
}

export function isAndroid(): boolean {
  return isCapacitor() && window.Capacitor!.getPlatform() === 'android'
}

export function isWeb(): boolean {
  return !isCapacitor()
}

/** The canonical HTTPS origin of the app — used for OAuth redirects, email links, etc. */
const APP_ORIGIN = 'https://anti-planning.com'

/**
 * Returns the app origin.
 * - On web: `window.location.origin` (respects subdomains)
 * - In Capacitor: the fixed HTTPS origin (since there's no real browser URL)
 */
export function getAppOrigin(): string {
  if (isCapacitor()) return APP_ORIGIN
  return window.location.origin
}
